<!--首页-->
<template>
  <div>
    <div class="box">
      <div class="row4" v-if="catelist.length > 0">
        <!--v-rblink="{name:'HuiyiList',query:{gametype:1}}"-->
        <!--v-rblink="{name:'NewsList',query:{cate_id:row.id}}"-->
        <img
          @click="setCurrent(1)"
          :class="currentIndex == 1 ? 'current' : ''"
          :src="catelist[0].pic_url"
        />
        <img
          @click="setCurrent(2)"
          :class="currentIndex == 2 ? 'current' : ''"
          :src="catelist[1].pic_url"
        />
        <img
          @click="setCurrent(3)"
          :class="currentIndex == 3 ? 'current' : ''"
          :src="catelist[2].pic_url"
        />
        <img
          @click="setCurrent(4)"
          :class="currentIndex == 4 ? 'current' : ''"
          :src="catelist[3].pic_url"
        />
        <img
          @click="setCurrent(row.id)"
          :class="currentIndex == row.id ? 'current' : ''"
          v-if="i > 3"
          v-for="(row, i) in catelist"
          :key="i"
          :src="row.pic_url"
        />
        <img
          v-rblink="{ name: 'CbaApplyFormBasic', query: { station_id: 5 } }"
          src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1607561416269-8.png"
        />
        <img
          v-rblink="{ name: 'CbaApplyFormBasic', query: { station_id: 6 } }"
          src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1607561416269-4.png"
        />
        <img
          v-rblink="{ name: 'CbaApplyFormBasic', query: { station_id: 4 } }"
          src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1607561416269-6.png"
        />
        <div style="clear: both"></div>
      </div>

      <div>
        <van-cell
          is-link
          v-rblink="{ name: 'HuiyiApplyList' }"
          title="我的会议培训"
          :label="'我报名的会议培训' + row.huiyi_join_count + '场'"
        >
          <template #default>
            <div class="badge" v-if="row.huiyi_count">
              {{ row.huiyi_count }}
            </div>
          </template>
        </van-cell>
      </div>

      <van-notice-bar
        wrapable
        v-if="false"
        :scrollable="false"
        text="请向下滑查看更多，请根据自己所属身份报名对应的培训（不得跨省报名）。"
      />

      <div v-if="currentIndex == 0">
        <van-collapse v-model="huiyiAcitiveCs" v-if="row.group_list.length > 0">
          <van-collapse-item
            :title="group.name"
            v-for="(group, gindex) in row.group_list"
            :key="gindex"
            :name="gindex + 1"
          >
            <van-notice-bar
              style="margin-bottom: 10px"
              wrapable
              :scrollable="false"
              :text="group.desc"
            />
            <div class="train-box flex-between" style="flex-wrap: wrap">
              <div
                class="train-items"
                v-for="(row, index) in group.list"
                :key="index"
                v-rblink="{
                  name: 'HuiyiApplyFormStep1',
                  query: { saiqu_id: row.id },
                }"
              >
                <div
                  class="train-items-top items-top1"
                  :style="
                    'background-image: linear-gradient(to right, #' +
                    row.color[0] +
                    ' , #' +
                    row.color[1] +
                    ');'
                  "
                >
                  <div>
                    <div class="train-items-top-city">{{ row.location }}</div>
                    <div class="train-items-top-time">{{ row.date_str }}</div>
                  </div>
                  <!--<div class="train-sing-up-btn">报名</div>-->
                </div>
                <div class="train-items-title">{{ row.name }}</div>
                <div class="flex-between" v-if="!row.is_pass">
                  <div class="train-items-time">{{ row.startdate }}</div>
                  <div class="train-items-address">
                    {{ row.province }}·{{ row.city }}
                  </div>
                </div>
                <div v-else style="color: #ed6a0c">
                  报名人数已满，请等待下一期
                </div>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div
        v-else-if="
          currentIndex == 1 ||
          currentIndex == 2 ||
          currentIndex == 3 ||
          currentIndex == 4
        "
      >
        <div class="more-box" v-if="huiyiList.length > 0" style="width:100%">
          <div class="train-box flex-between" style="flex-wrap: wrap">
            <div
              class="train-items"
              v-for="(row, index) in huiyiList"
              :key="index"
              v-rblink="{
                name: 'HuiyiApplyFormStep1',
                query: { saiqu_id: row.id },
              }"
            >
              <div
                class="train-items-top items-top1"
                :style="
                  'background-image: linear-gradient(to right, #' +
                  row.color[0] +
                  ' , #' +
                  row.color[1] +
                  ');'
                "
              >
                <div>
                  <div class="train-items-top-city">{{ row.location }}</div>
                  <div class="train-items-top-time">{{ row.date_str }}</div>
                </div>
                <!--<div class="train-sing-up-btn">报名</div>-->
              </div>
              <div class="train-items-title">{{ row.name }}</div>
              <div class="flex-between">
                <div class="train-items-time">{{ row.startdate }}</div>
                <div class="train-items-address">
                  {{ row.province }}·{{ row.city }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-empty v-else description="暂无场次" />
      </div>
      <div v-else-if="currentIndex > 10">
        <div class="box" v-if="news_list.length > 0">
          <!--<van-pull-refresh v-model="isLoading" @refresh="onRefresh">-->
          <!--<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">-->
          <div
            v-for="(row, i) in news_list"
            :key="i"
            v-rblink="{ name: 'NewsDetail', query: { id: row.id } }"
          >
            <!-- 无图 style==1 -->
            <NewsItem1 :row="row" v-if="row.pics.length == 0"></NewsItem1>
            <!-- 有图 style==2 -->
            <NewsItem2 :row="row" v-if="row.pics.length == 1"></NewsItem2>
            <!-- 视频 style==3 -->
            <NewsItem3 v-if="false"></NewsItem3>
            <!-- 多图 style==4 -->
            <NewsItem4 :row="row" v-if="row.pics.length > 1"></NewsItem4>
          </div>
          <!--</van-list>-->
          <!--</van-pull-refresh>-->
        </div>

        <van-empty v-else description="暂无内容" />
      </div>

      <div class="more-box" v-if="false" v-show="row.doing.length > 0">
        <div class="more-active">
          <div style="display: flex; align-items: center">
            <div class="solid solid2"></div>
            <span class="more-title">正在报名 </span>
          </div>
          <!--<div style="display:flex;align-items: center">-->
          <!--<div class="more-right">更多</div>-->
          <!--<img src="../../../assets/images/arrow.png" alt="" srcset="">-->
          <!--</div>-->
        </div>

        <div class="main-solid"></div>
        <div class="train-box flex-between" style="flex-wrap: wrap">
          <div
            class="train-items"
            v-for="(row, index) in row.doing"
            :key="index"
            v-rblink="{
              name: 'HuiyiPcStep1',
              query: { saiqu_id: row.id },
            }"
          >
            <div
              class="train-items-top items-top1"
              :style="
                'background-image: linear-gradient(to right, #' +
                row.color[0] +
                ' , #' +
                row.color[1] +
                ');'
              "
            >
              <div>
                <div class="train-items-top-city">{{ row.location }}</div>
                <div class="train-items-top-time">{{ row.date_str }}</div>
              </div>
              <!--<div class="train-sing-up-btn">报名</div>-->
            </div>
            <div class="train-items-title">{{ row.name }}</div>
            <div class="flex-between">
              <div class="train-items-time">{{ row.startdate }}</div>
              <div class="train-items-address">
                {{ row.province }}·{{ row.city }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <LoginDialog
        :show="loginShow"
        @loginSuccess="loginSuccess"
        @loginCancel="loginCancel"
      />
    </div>
  </div>
</template>
<style scoped>
/* @import '../../assets/style/index.css'; */
.box{
    width: 1340px;
    min-height: 560px;
    background: #ffffff;
    box-sizing: border-box;
}
.row4 {
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  margin: 10px 10px;
  /*flex-wrap: wrap;*/
}
.row4 img {
  width: 100%;
  float: left; 
  width: calc(9% - 10px);
  margin: 0 10px 10px 0;
}
.row4 img.current {
  box-shadow: 0px 0px 10px 0px rgba(119, 175, 255, 1);
}
.more-box {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.more-active {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.more-items {
  width: 2.02rem;
  position: relative;
  display: flex;
  align-items: center;
}
.more-items img {
  width: 2.02rem;
}
.more-items span {
  font-size: 14px;
  font-family: "PingFangSC-Regular,PingFang SC";
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  left: 7px;
}

.more-active .solid {
  width: 4px;
  height: 25px;
  border-radius: 4px;
  margin-right: 5px;
}
.more-active .more-title {
  color: #333;
  font-size: 16px;
  height: 25px;
  line-height: 25px;
}
.more-active .more-right {
  color: #333;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}
.more-active img {
  margin-left: 5px;
  width: 5.5px;
  height: 10px;
}
.main-solid {
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin: 10px 0;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.fontFamily {
  font-family: "PingFangSC-Regular,PingFang SC";
}

.train-items {
  width: 23.5%;
  margin-bottom: 30px;
}

.items-top1 {
  background-image: linear-gradient(to right, #01ea9b, #8dec9d);
}
.items-top2 {
  background-image: linear-gradient(to right, #2b7aff, #1eb2ff);
}

.train-items-top {
  width: 100%;
  height: 100px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.train-items-top-city {
  color: #fff;
  font-size: 28px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
}
.train-items-top-time {
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
}
.train-sing-up-btn {
  width: 48px;
  height: 26px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  font-family: "PingFangSC-Medium,PingFang SC";
  border: 1px solid #fff;
  border-radius: 26px;
  text-align: center;
  line-height: 26px;
}
.train-items-title {
  color: #333;
  font-size: 14px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
  margin: 5px 0;
}
.train-items-time,
.train-items-address {
  color: #595757;
  font-size: 12px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
}
.train-items-address {
  margin-right: 10px;
}

.box {
  background: #f8f8f8;
  width: 80%;
  margin: 0 auto;
  margin-bottom: 50px;
  overflow: hidden;
}
</style>

<script>
import Vue from "vue";
import TabBar from "@/components/TabBar.vue";
import LoginDialog from "@/components/LoginDialog.vue";
import { NoticeBar, Collapse, CollapseItem, Empty } from "vant";

import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";

Vue.use(NoticeBar);
Vue.use(CollapseItem);
Vue.use(Collapse);
Vue.use(Empty);

export default {
  name: "HuiyiIndex",
  components: {
    TabBar,
    LoginDialog,
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
  },
  data: function () {
    return {
      currentIndex: 0,
      huiyiAcitiveCs: [],
      loginShow: false,
      showTabBar: false,
      row: {
        group_list: [],
        news_list: [],
        doing: [],
        going: [],
        pass: [],
      },
      catelist: [],
    };
  },
  filter: {},
  computed: {
    huiyiList() {
      let that = this;
      return this.row.doing.filter((item) => {
        return item.gametype == that.currentIndex;
      });
    },
    news_list() {
      let that = this;
      if (that.currentIndex < 10) {
        return [];
      }
      return this.row.news_list["i" + that.currentIndex];
    },
  },
  mounted() {
    document.title = "会议培训";
    this.showTabBar = window.isApp() ? false : true;
    let that = this;
    that.$api.get(
      "/api/cms/catelist",
      {
        parent_id: 72,
      },
      (res) => {
        that.catelist = res.data;
      },
      (res) => {
        Toast(res.msg);
      }
    );

    this.fetch();
  },
  destroyed() {},
  methods: {
    setCurrent(index) {
      this.currentIndex = this.currentIndex == index ? 0 : index;
    },
    fetch() {
      let that = this;
      this.$api.get(
        "/api/huiyi/indexData",
        {},
        (res) => {
          console.log(res);
          that.row = res.data;
        },
        (res) => {
          console.log("没有登录");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// HuiyiIndex.vue?04f06a16